export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/gl-logo-full.0012e0fd.svg","height":24,"width":155};